const styles = {
  banner: {
    backgroundColor: "#f2f3ff",
    px: 3,
    py: 2,
    borderRadius: 4,
    mb: 3,
    alignItems: "center",
    gap: 2,
  },
  chip: {
    backgroundColor: "white",
    color: "purple.dark",
    fontWeight: 600,
    fontSize: 11,
    textTransform: "uppercase",
    letterSpacing: 0.5,
    mb: 1,
  },
  button: {
    color: "purple.dark",
    backgroundColor: "white",
    borderRadius: 2,
    borderColor: "purple.dark",
    fontSize: { xs: 12, md: 14 },
    px: 3,
    py: 1,
  },
};

export default styles;
